import { FONTS } from '../../config/app-config';
// src/components/filters/FilterPanel.js
import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import FilterList from './FilterList';
import ProductSelector from '../navigation/header/ProductSelector';
import VersionSelector from '../navigation/header/VersionSelector';

import { useReleaseOptions } from '../../contexts/ReleaseOptionsContext';

const FilterPanel = ({
                         filterTree,
                         selectedFilters,
                         onChangeFilters,
                         selectedRelease,
                         setSelectedRelease,
    }) => {
    const { availableVersions, availableProducts } = useReleaseOptions();

    console.log(availableVersions, availableProducts);

    return (
        <Box
            sx={{
                width: '100%',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            {/* Dropdown-Selectors */}
            <Typography sx={{ fontFamily: FONTS.heading, fontSize: 16, fontWeight: 600, mb: 2 }}>
                Filters
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    gap: 2,
                }}
            >
                <ProductSelector
                    options={availableProducts}
                    selectedRelease={selectedRelease}
                    setSelectedRelease={setSelectedRelease}
                />
                <VersionSelector
                    options={availableVersions.map(v => ({
                        code: v.code,
                        displayName: v.displayName || v.code,
                    }))}
                    selectedRelease={selectedRelease}
                    setSelectedRelease={setSelectedRelease}
                />
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Path Filters */}
            <Typography sx={{ fontFamily: FONTS.heading, fontSize: 16, fontWeight: 600, mb: 1 }}>
                Path
            </Typography>

            <Box
                sx={{
                    width: '100%',
                    minHeight: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    overflowY: 'scroll',
                }}
            >
                <FilterList
                    nodeData={filterTree}
                    path={[]}
                    onFilterToggle={(pathString, isSelected) => {
                        if (isSelected) {
                            onChangeFilters([...selectedFilters, pathString]);
                        } else {
                            onChangeFilters(selectedFilters.filter(p => p !== pathString));
                        }
                    }}
                    selectedFilters={selectedFilters}
                />
            </Box>
        </Box>
    );
};

export default FilterPanel;

